import { IconButton, Tooltip } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';

import useSettings from '../hooks/useSettings';
import { THEMES } from '../constants';

// Quick light / dark flip that lives in the dashboard navbar. The
// SettingsDrawer still owns the full theme picker (NATURE etc.) — this
// button is here so the most common toggle is one click away. We treat
// any non-DARK theme as "currently light" so clicking always flips to
// DARK if the user happens to be on NATURE.
const ThemeToggleButton = () => {
  const { settings, saveSettings } = useSettings();
  const isDark = settings.theme === THEMES.DARK;

  const toggle = () => {
    saveSettings({
      ...settings,
      theme: isDark ? THEMES.LIGHT : THEMES.DARK,
    });
  };

  return (
    <Tooltip title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}>
      <IconButton color="inherit" onClick={toggle} aria-label="Toggle theme">
        {isDark ? <LightModeIcon /> : <DarkModeIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggleButton;
